import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function Services() {
  const services = [{
    title: 'In-Person and Virtual PT',
    price: 'Evaluation & Treatment Sessions',
    description: 'One-on-one sessions designed to understand your situation and guide your progress every step of the way.',
    features: ['Detailed history and goal setting', 'Objective assessment and physical testing', 'Hands-on assessment as needed', 'Individualized exercise instruction', 'Skill development and movement practice', 'Building strength, capacity, and confidence'],
    highlighted: false,
    image: 'https://cdn.magicpatterns.com/uploads/nBbWR557z149baLXUu2DRm/94-IMG_5381.jpg'
  }, {
    title: 'Hybrid PT',
    price: 'Most Popular',
    description: 'The ultimate blend of in-person care and remote programming for long-term success.',
    features: ['In-person sessions based on need', 'Custom weekly programming via app', 'Form review & video analysis', '24/7 direct messaging access', 'Education and guidance on your pain'],
    highlighted: true,
    image: null
  }, {
    title: 'Remote Coaching',
    price: 'Training & Rehab',
    description: 'For those out of the area or transitioning from rehab back to full performance training.',
    features: ['Virtual initial assessment', 'Customized training blocks', 'Weekly check-ins & adjustments', 'Video movement analysis'],
    highlighted: false,
    image: 'https://cdn.magicpatterns.com/uploads/svBgaz8zUTdbxt8RUo7Pmg/22-IMG_5152.jpg'
  }];
  return <section id="services" className="py-24 bg-offwhite-100" data-id="element-161">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-162">
        <div className="text-center mb-16" data-id="element-163">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-bold text-charcoal-950 mb-4" data-id="element-164">
            Services & Packages
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl text-charcoal-800 max-w-2xl mx-auto" data-id="element-165">
            Tailored solutions to get you out of pain and performing at your
            peak.
          </motion.p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8 items-center" data-id="element-166">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className={`rounded-3xl overflow-hidden ${service.highlighted ? 'bg-charcoal-950 text-offwhite-50 shadow-2xl scale-100 lg:scale-105 z-10 border border-charcoal-800 relative' : 'bg-white text-charcoal-950 shadow-lg border border-offwhite-200'}`} data-id="element-167">
              {service.image && <div className="h-48 w-full overflow-hidden" data-id="element-168">
                  <img src={service.image} alt={service.title} className="w-full h-full object-cover" data-id="element-169" />
                </div>}
              <div className={`p-8 md:p-10 ${service.highlighted ? 'relative overflow-hidden' : ''}`} data-id="element-170">
                {service.highlighted && <div className="absolute top-0 right-0 bg-amber-500 text-charcoal-950 text-xs font-bold px-4 py-1 rounded-bl-lg uppercase tracking-wider" data-id="element-171">
                    Recommended
                  </div>}
                <h3 className="text-2xl font-bold mb-2" data-id="element-172">{service.title}</h3>
                <p className={`text-sm font-semibold uppercase tracking-wider mb-6 ${service.highlighted ? 'text-amber-500' : 'text-charcoal-500'}`} data-id="element-173">
                  {service.price}
                </p>
                <p className={`mb-8 leading-relaxed ${service.highlighted ? 'text-offwhite-200' : 'text-charcoal-800'}`} data-id="element-174">
                  {service.description}
                </p>

                <ul className="space-y-4 mb-10" data-id="element-175">
                  {service.features.map((feature, i) => <li key={i} className="flex items-start gap-3" data-id="element-176">
                      <CheckIcon size={20} className={`flex-shrink-0 mt-0.5 ${service.highlighted ? 'text-amber-500' : 'text-charcoal-950'}`} data-id="element-177" />
                      <span className={service.highlighted ? 'text-offwhite-100' : 'text-charcoal-800'} data-id="element-178">
                        {feature}
                      </span>
                    </li>)}
                </ul>

                <a href="https://calendly.com/dylanmclean-mcleanphysicaltherapy/consult-call" target="_blank" rel="noopener noreferrer" className={`block w-full text-center py-4 rounded-xl font-bold transition-all ${service.highlighted ? 'bg-amber-500 hover:bg-amber-400 text-charcoal-950' : 'bg-charcoal-950 hover:bg-charcoal-800 text-white'}`} data-id="element-179">
                  Inquire Now
                </a>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}